// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mypage-container {
  height: calc(100vh - 98px);
  overflow-y: auto;
  padding-top: 15px;
}

.mypage-sub-container {
  height: 100%;
  overflow-y: auto;
}

.mypage-edit {
  background-color: #fbe5d6;
  border-radius: 5px;
  padding: 0.1rem 1rem;
}

.mypage-info-items {
  width: 17%;
}

.mypage-content-box {
  padding: 0 24px 15px 24px;
}

.mypage-title-icon {
  width: 36px;
  height: 36px;
  margin-right: 8px;
}

.mypage-title {
  font-size: 27.5px;
}

.mypage-info-container {
  display: flex;
  gap: 0 10px;
}

.mypage-info-container>div {
  width: 230px;
}

.mypage-info-container {
  word-wrap: break-word;
}

.mypage-inquiry-box {
  background-color: #efefef;
  max-height: 450px;
  overflow-y: auto;
}

.mypage-inquiry-content-box {
  display: flex;
  flex-direction: column;
  gap: 0.5rem 0;
}

.mypage-inquiry-content {
  background-color: #fff;
  border-radius: 5px;
}

.new-inquiry-btn {
  border: 1px dashed #a5a5a5;
  background-color: #fff;
  width: 30%;
  border-radius: 5px;
  text-align: center;
  padding: 2px 0;
}

.new-inquiry-box {
  background-color: #efefef;
}

.new-inquiry-input {
  background-color: transparent;
  border: 0;
  width: 100%;
  outline: none;
  padding: 0;
}

.new-inquiry-input::placeholder {
  color: #ababab;
}

.mypage-file-box {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  gap: 1rem;
}

.new-inquiry-textarea {
  resize: none;
  height: 180px;
}

.new-inquiry-submit {
  border-radius: 5px;
  padding: 0.5rem 2.75rem;
  text-align: center;
}

.mypage-gray-btn {
  background-color: #b2b2b2;
  /* height: 40px; */
  border-radius: 5px;
  text-align: center;
  /* padding: .5rem 1rem; */
  padding-left: 1rem;
  padding-right: 1rem;
  /* line-height: 40px; */
  height: 37.94px;
  line-height: 37.94px;
}

.mypage-gray-btn2 {
  background-color: #b2b2b2;
  /* height: 40px; */
  border-radius: 5px;
  text-align: center;
  padding: 0.5rem 2.75rem;
}

.logout-btn {
  background-color: #971b4d;
  border-radius: 5px;
}

.mypage-title-content {
  margin-bottom: 20px;
}

.mypage-input {
  width: 100%;
  background-color: #efefef;
  outline: none;
  border: 0;
  border-radius: 5px;
}

.mypage-select select {
  background-color: #efefef;
  border: 0;
}

.mypage-select select:focus {
  box-shadow: none;
}

.modal-content {
  border: 0;
}

.mypage-title-text {
  font-size: 22.5px;
}

.my-edit-btn {
  display: inline-block;
  cursor: pointer;
  border-radius: 0.25em;
  color: #fff;
  font-size: 1em;
  margin: 0.3125em;
  padding: 0.625em 1.1em;
  transition: box-shadow 0.1s;
  /* box-shadow: 0 0 0 3px rgba(0,0,0,0); */
  font-weight: 500;
}

.my-edit-btn:active {
  background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
}

.edit-gray {
  background-color: #6e7881;
}

.parent-user-box {
  margin-left: 17.66px;
}

.my-user-box {
  margin-right: 45px;
}

.my-fc-ABABAB {
  color: #ababab;
}

.my-text-margin-top {
  margin-top: 1px;
}

.my-logout-btn {
  width: 91.66px;
}

.my-same-btn {
  width: 175px;
}

@media (max-width: 1300px) {
  .mypage-box {
    padding-left: 0;
    margin-left: 0;
    background-color: #fff;
  }

  .mypage-bg-box {
    /* padding-bottom: 120px; */
  }

  .mypage-container {
    width: 100%;
  }
}

@media (max-width: 1280px) {
  .mypage-container {
    height: calc(100vh - 184.09px);
  }

  .mypage-content-box {
    padding-left: 36px;
    padding-right: 36px;
  }

  .mypage-info-edit-modal {
    max-height: 60vh;
    overflow-y: auto;
  }
}

@media (max-width: 768px) {
  .my-same-btn {
    width: 175px;
  }

  .mypage-info-edit-modal {
    max-height: 55vh;
    overflow-y: auto;
  }

  .mypage-file-box {
    gap: 0.5rem;
  }

  .mypage-container {
    padding-top: 0;
  }

  .mypage-title-text {
    font-size: 16px;
  }

  .new-inquiry-textarea {
    height: 15vh;
  }

  .mypage-container {
    height: calc(100vh - 129.09px);
  }

  .mypage-title-content {
    margin-bottom: 15px;
  }

  .mypage-content-box {
    padding: 17px 13px;
  }

  .mypage-box {
    padding-top: 10px;
  }

  .mypage-title {
    font-size: 19px;
  }

  .mypage-title-icon {
    width: 25px;
    height: 25px;
    margin-right: 5px;
  }

  .parent-user-box {
    margin-left: 13.66px;
  }

  .my-user-box {
    margin-right: 8px;
  }

  .my-text-margin-top {
    margin-top: 0;
  }

  .my-logout-btn {
    width: 72.89px;
  }
}

@media (max-width: 576px) {
  .my-same-btn {
    width: 90px;
  }

  .new-inquiry-submit,
  .mypage-gray-btn,
  .mypage-gray-btn2 {
    padding: 0.5rem;
  }
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 80vw;
  }
}

@media (min-width: 769px) {
  .edit-modal .modal-dialog {
    max-width: 60vw;
  }
}

@media (min-width: 1281px) {
  .modal-dialog {
    max-width: 50vw;
  }

  .edit-modal .modal-dialog {
    max-width: 40vw;
  }
}

.mypage-quill .ql-toolbar.ql-snow {
  border: 0;
}

.mypage-quill .ql-container.ql-snow {
  border: 0;
}

.mypage-view-quill .ql-toolbar {
  display: none;
}

.mypage-view-quill .ql-container {
  border: 0;
}

.mypage-view-quill .ql-editor {
  padding: 4px 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/mypage/mypage.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".mypage-container {\n  height: calc(100vh - 98px);\n  overflow-y: auto;\n  padding-top: 15px;\n}\n\n.mypage-sub-container {\n  height: 100%;\n  overflow-y: auto;\n}\n\n.mypage-edit {\n  background-color: #fbe5d6;\n  border-radius: 5px;\n  padding: 0.1rem 1rem;\n}\n\n.mypage-info-items {\n  width: 17%;\n}\n\n.mypage-content-box {\n  padding: 0 24px 15px 24px;\n}\n\n.mypage-title-icon {\n  width: 36px;\n  height: 36px;\n  margin-right: 8px;\n}\n\n.mypage-title {\n  font-size: 27.5px;\n}\n\n.mypage-info-container {\n  display: flex;\n  gap: 0 10px;\n}\n\n.mypage-info-container>div {\n  width: 230px;\n}\n\n.mypage-info-container {\n  word-wrap: break-word;\n}\n\n.mypage-inquiry-box {\n  background-color: #efefef;\n  max-height: 450px;\n  overflow-y: auto;\n}\n\n.mypage-inquiry-content-box {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem 0;\n}\n\n.mypage-inquiry-content {\n  background-color: #fff;\n  border-radius: 5px;\n}\n\n.new-inquiry-btn {\n  border: 1px dashed #a5a5a5;\n  background-color: #fff;\n  width: 30%;\n  border-radius: 5px;\n  text-align: center;\n  padding: 2px 0;\n}\n\n.new-inquiry-box {\n  background-color: #efefef;\n}\n\n.new-inquiry-input {\n  background-color: transparent;\n  border: 0;\n  width: 100%;\n  outline: none;\n  padding: 0;\n}\n\n.new-inquiry-input::placeholder {\n  color: #ababab;\n}\n\n.mypage-file-box {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n  gap: 1rem;\n}\n\n.new-inquiry-textarea {\n  resize: none;\n  height: 180px;\n}\n\n.new-inquiry-submit {\n  border-radius: 5px;\n  padding: 0.5rem 2.75rem;\n  text-align: center;\n}\n\n.mypage-gray-btn {\n  background-color: #b2b2b2;\n  /* height: 40px; */\n  border-radius: 5px;\n  text-align: center;\n  /* padding: .5rem 1rem; */\n  padding-left: 1rem;\n  padding-right: 1rem;\n  /* line-height: 40px; */\n  height: 37.94px;\n  line-height: 37.94px;\n}\n\n.mypage-gray-btn2 {\n  background-color: #b2b2b2;\n  /* height: 40px; */\n  border-radius: 5px;\n  text-align: center;\n  padding: 0.5rem 2.75rem;\n}\n\n.logout-btn {\n  background-color: #971b4d;\n  border-radius: 5px;\n}\n\n.mypage-title-content {\n  margin-bottom: 20px;\n}\n\n.mypage-input {\n  width: 100%;\n  background-color: #efefef;\n  outline: none;\n  border: 0;\n  border-radius: 5px;\n}\n\n.mypage-select select {\n  background-color: #efefef;\n  border: 0;\n}\n\n.mypage-select select:focus {\n  box-shadow: none;\n}\n\n.modal-content {\n  border: 0;\n}\n\n.mypage-title-text {\n  font-size: 22.5px;\n}\n\n.my-edit-btn {\n  display: inline-block;\n  cursor: pointer;\n  border-radius: 0.25em;\n  color: #fff;\n  font-size: 1em;\n  margin: 0.3125em;\n  padding: 0.625em 1.1em;\n  transition: box-shadow 0.1s;\n  /* box-shadow: 0 0 0 3px rgba(0,0,0,0); */\n  font-weight: 500;\n}\n\n.my-edit-btn:active {\n  background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));\n}\n\n.edit-gray {\n  background-color: #6e7881;\n}\n\n.parent-user-box {\n  margin-left: 17.66px;\n}\n\n.my-user-box {\n  margin-right: 45px;\n}\n\n.my-fc-ABABAB {\n  color: #ababab;\n}\n\n.my-text-margin-top {\n  margin-top: 1px;\n}\n\n.my-logout-btn {\n  width: 91.66px;\n}\n\n.my-same-btn {\n  width: 175px;\n}\n\n@media (max-width: 1300px) {\n  .mypage-box {\n    padding-left: 0;\n    margin-left: 0;\n    background-color: #fff;\n  }\n\n  .mypage-bg-box {\n    /* padding-bottom: 120px; */\n  }\n\n  .mypage-container {\n    width: 100%;\n  }\n}\n\n@media (max-width: 1280px) {\n  .mypage-container {\n    height: calc(100vh - 184.09px);\n  }\n\n  .mypage-content-box {\n    padding-left: 36px;\n    padding-right: 36px;\n  }\n\n  .mypage-info-edit-modal {\n    max-height: 60vh;\n    overflow-y: auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .my-same-btn {\n    width: 175px;\n  }\n\n  .mypage-info-edit-modal {\n    max-height: 55vh;\n    overflow-y: auto;\n  }\n\n  .mypage-file-box {\n    gap: 0.5rem;\n  }\n\n  .mypage-container {\n    padding-top: 0;\n  }\n\n  .mypage-title-text {\n    font-size: 16px;\n  }\n\n  .new-inquiry-textarea {\n    height: 15vh;\n  }\n\n  .mypage-container {\n    height: calc(100vh - 129.09px);\n  }\n\n  .mypage-title-content {\n    margin-bottom: 15px;\n  }\n\n  .mypage-content-box {\n    padding: 17px 13px;\n  }\n\n  .mypage-box {\n    padding-top: 10px;\n  }\n\n  .mypage-title {\n    font-size: 19px;\n  }\n\n  .mypage-title-icon {\n    width: 25px;\n    height: 25px;\n    margin-right: 5px;\n  }\n\n  .parent-user-box {\n    margin-left: 13.66px;\n  }\n\n  .my-user-box {\n    margin-right: 8px;\n  }\n\n  .my-text-margin-top {\n    margin-top: 0;\n  }\n\n  .my-logout-btn {\n    width: 72.89px;\n  }\n}\n\n@media (max-width: 576px) {\n  .my-same-btn {\n    width: 90px;\n  }\n\n  .new-inquiry-submit,\n  .mypage-gray-btn,\n  .mypage-gray-btn2 {\n    padding: 0.5rem;\n  }\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 80vw;\n  }\n}\n\n@media (min-width: 769px) {\n  .edit-modal .modal-dialog {\n    max-width: 60vw;\n  }\n}\n\n@media (min-width: 1281px) {\n  .modal-dialog {\n    max-width: 50vw;\n  }\n\n  .edit-modal .modal-dialog {\n    max-width: 40vw;\n  }\n}\n\n.mypage-quill .ql-toolbar.ql-snow {\n  border: 0;\n}\n\n.mypage-quill .ql-container.ql-snow {\n  border: 0;\n}\n\n.mypage-view-quill .ql-toolbar {\n  display: none;\n}\n\n.mypage-view-quill .ql-container {\n  border: 0;\n}\n\n.mypage-view-quill .ql-editor {\n  padding: 4px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
